import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-357d9422")

_pushScopeId("data-v-357d9422")
const _hoisted_1 = {
  class: "select-category-item",
  id: "select-category-item-top"
}
const _hoisted_2 = { class: "select-category-item-button-textarea" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory())),
      class: "select-category-item-button"
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", {
          class: "select-category-item-button-textarea-text",
          style: _ctx.styleTextColorSelected
        }, _toDisplayString(_ctx.categoryName), 5)
      ]),
      _createVNode("div", {
        class: "select-category-item-button-select-indicator",
        style: _ctx.styleOpacitySelected
      }, null, 4)
    ])
  ]))
})